import React from "react";
import {maybeLicense, isUnfree} from "./license";

// Platforms this widget shows.
const PLATFORMS = [
	//"i686-linux",
	//"aarch64-linux",
	"x86_64-linux",
];

const hydraLink = (attribute, platform) =>
	`https://hydra.nixos.org/job/nixos/release-17.09/nixpkgs.${attribute}.${platform}`;

const githubLink = (commit, position) => 
	`https://github.com/NixOS/nixpkgs/blob/${commit}/${position.replace(":", "#L")}`;

const Maybe = ({value, condition}) => {
	if (condition === undefined) {
		condition = !!value;
	}

	if (condition) {
		return value;
	}
	else {
		return <em>Not specified</em>;
	}
}

const LineDetails = ({
	commit,
	name,
	attribute,
	meta: {
		description,
		longDescription,
		position,
		maintainers,
		license,
		homepage,
		platforms,
	}
}) =>
	<tr className={["details", isUnfree(license) ? "is-unfree" : "is-free"].join(" ")}>
		<td colSpan="3">
			<div className="search-details">
				<table>
					<tbody>
						<tr>
							<th>Install command:</th>
							<td>
								<tt>
									<span className="command">
										nix-env -iA nixos.<span className="attrname">{attribute}</span>
									</span>
								</tt>
								<em className="muted">{" "}(NixOS channel)</em>
							</td>
						</tr>
						{isUnfree(license) &&
						<tr>
							<td colSpan="2" className="unfree-note">
								<em>
									This package is unfree.
									See <a href="https://nixos.org/nixpkgs/manual/#sec-allow-unfree">chapter 6.2</a> of
									the manual for more informations.
								</em>
							</td>
						</tr>
						}
						<tr>
							<th>Nix expression:</th>
							<td className="nix-expr">
								<Maybe
									condition={position}
									value={<a href={githubLink(commit, position||"")}>{(position||"").replace(/:[0-9]+$/, "")}</a>}
								/>
							</td>
						</tr>
						<tr>
							<th>Platforms:</th>
							<td className="platforms">
								<Maybe
									condition={platforms && platforms.length > 0}
									value={
										<ul className="platforms-list">
											{
												(platforms||[])
													.filter((platform) => PLATFORMS.indexOf(platform) > -1)
													.map((platform, key) =>
														<li key={key}>
															<a className={`platform-is-${platform}`} href={hydraLink(attribute, platform)}><tt>{platform}</tt></a>
														</li>
													)
											}
										</ul>
									}
								/>
							</td>
						</tr>
						<tr>
							<th>Homepage:</th>
							<td className="homepage">
								<Maybe
									condition={homepage && homepage.length > 0}
									value={<a href={homepage}>{homepage}</a>}
								/>
							</td>
						</tr>
						<tr>
							<th>License:</th>
							<td className="license"><Maybe value={maybeLicense(license)} /></td>
						</tr>
						<tr>
							<th>Maintainers:</th>
							<td className="maintainers">
								<Maybe value={[].concat(maintainers||[]).join(", ")} condition={maintainers && maintainers.length > 0} />
							</td>
						</tr>
						<tr>
							<th style={{width: "10em"}}>Long description:</th>
							<td className="long-description">
								<Maybe
									condition={!!longDescription && !longDescription.match(/^\s+$/)}
									value={<pre>{longDescription}</pre>}
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</td>
	</tr>
;

const Line = (props) => {
	const {
		className,
		name,
		attribute,
		meta: {
			description,
			license,
		},
		handleOpen,
		opened,
	} = props;

	const rows = [
		<tr
			key="result"
			onClick={() => handleOpen(attribute)}
			className={[className, isUnfree(license) ? "is-unfree" : "is-free"].join(" ")}
		>
			<td><button onClick={() => handleOpen(attribute)}>{name}</button></td>
			<td>{attribute}</td>
			<td>{description}</td>
		</tr>
	];

	// Bypass array render if possible.
	if (!opened) { return rows[0]; }

	rows.push(<LineDetails key="details" {...props} />);

	return rows;
};


export default Line;



// WEBPACK FOOTER //
// ./src/line.js